import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { PushTokenState, PushTokenActions } from "./types";

const usePushTokenStore = create<PushTokenState & PushTokenActions>()(
  persist(
    (set) => ({
      pushToken: null,
      setPushToken: (pushToken) => set({ pushToken }),
    }),
    {
      name: "push-token",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default usePushTokenStore;
